import { Component, OnInit } from '@angular/core';
import { InputComponent } from '../../utilities/input/input.component';
import { OtpFieldComponent } from '../../components/otp-field/otp-field.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ButtonComponent } from '../../utilities/button/button.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [InputComponent, CommonModule, ButtonComponent, OtpFieldComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  texts: string[] = [
    'Welcome Back! Your Security, Our Priority',
    'Access Secure Transactions with Confidence',
    'Login to Manage and Protect Card Data',
  ];
  currentText: string = '';
  isDeleting: boolean = false;
  loopIndex: number = 0;
  charIndex: number = 0;
  typingSpeed: number = 150;
  backspaceSpeed: number = 75;
  pauseTime: number = 1000;
  loading: boolean = false;
  OTPState: boolean = false;
  otp: string = '';
  otpId: string = '';
  loginData: any = {
    emailAddress: '',
    password: '',
  };
  errors: any = {
    emailAddress: '',
    password: '',
    otp: ''
  };
  loginResponse: any;
  otpResponse: any;
  constructor(
    private router: Router,
    private authService: AuthService,
    private notification: NzNotificationService,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {
    this.startTypingEffect();
  }
  routeTo = (route: string) => {
    this.generalService.routeTo(route);
  };

  startTypingEffect(): void {
    const currentIndex = this.loopIndex % this.texts.length;
    const fullText = this.texts[currentIndex];

    if (this.isDeleting) {
      this.currentText = fullText.substring(0, this.charIndex--);
    } else {
      this.currentText = fullText.substring(0, this.charIndex++);
    }

    if (!this.isDeleting && this.charIndex === fullText.length) {
      setTimeout(() => (this.isDeleting = true), this.pauseTime);
    } else if (this.isDeleting && this.charIndex === 0) {
      this.isDeleting = false;
      this.loopIndex++;
      setTimeout(() => this.startTypingEffect(), this.pauseTime);
      return;
    }

    const speed = this.isDeleting ? this.backspaceSpeed : this.typingSpeed;
    setTimeout(() => this.startTypingEffect(), speed);
  }

  handleInput(data: { title: string; value: string }) {
    this.loginData[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  setEmail = (value: string) => {
    this.loginData.emailAddress = value;
    if (value === '') {
      this.errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(value)) {
      this.errors.emailAddress = 'Please use a valid email*';
    } else {
      this.errors.emailAddress = '';
    }
  };

  setOTP = (otp: string) => {
    this.otp = otp;
    if (this.otp.length == 6) {
      this.verifyOTP();
    }
  };
  validateForm = () => {
    const errors: any = {};
    if (this.loginData.password === '') {
      errors.password = 'Required*';
    }
    if (this.loginData.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(this.loginData.emailAddress)) {
      errors.emailAddress = 'Please use a valid email*';
    }
    // console.log(errors);
    return errors;
  };
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  signIn = () => {
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
      this.loading = true;
      this.authService.signin(this.loginData).subscribe(
        (res: any) => {
          this.loginResponse = res.data;
          this.notification.success('Success', res.message, {
            nzClass: 'notification',
          });
          this.OTPState = true;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.notification.error('Error', 'Something went wrong', {
            nzClass: 'notification',
          });
        }
      );
    }
  };
  verifyOTP() {
    const OTPData = {
      emailAddress: this.loginData.emailAddress,
      code: this.otp,
      trackingId: this.loginResponse.trackingId,
      method: this.loginResponse.twoFactorMethods[0],
    };
    console.log(OTPData);
    if (this.otp.length != 6) {
      this.errors.otp = 'OTP must be 6 digits*'; return
    } else {
      this.loading = true;
      this.authService.verifyOTP(OTPData).subscribe(
        (res: any) => {
          console.log(res);
          this.otpResponse = res.data;
          this.generalService.setToken(res.data.token);
          localStorage.setItem('userPermissions', JSON.stringify(res.data.user.membership.roles[0].permissions));
          this.notification.success('Success', 'Sign In Successful', {
            nzClass: 'notification',
          });
          this.loading = false;
          this.generalService.routeTo('dashboard');
        },
        (error) => {
          this.loading = false;
          this.notification.error('Error', 'Something went wrong', {
            nzClass: 'notification',
          });
        }
      );
    }
  }
}
// {
//   "statusCode": 200,
//   "message": "Login successful",
//   "data": {
//       "user": {
//           "_id": "67f4d4db73d24cc442e1def4",
//           "firstName": "Kedonojo",
//           "lastName": "Ameh",
//           "emailAddress": "david.ameh37@gmail.com",
//           "emailAddressVerified": false,
//           "phoneNumber": "+23409090397622",
//           "twoFactorAuthEnabled": true,
//           "twoFactorAuthMethods": [
//               {
//                   "id": "67f4d4db73d24cc442e1defc",
//                   "type": "EmailOTP",
//                   "purpose": "TwoFactor"
//               }
//           ],
//           "isBlocked": false,
//           "status": "active",
//           "organizations": [
//               {
//                   "_id": "67f4d4db73d24cc442e1def6",
//                   "name": "Ameh Enterprises",
//                   "registrationCountry": "Nigeria",
//                   "address": {
//                       "street": "Wuse 2",
//                       "city": "Abuja",
//                       "state": "FCT",
//                       "country": "Nigeria",
//                       "_id": "67f4d4db73d24cc442e1def7"
//                   },
//                   "emailAddress": "david.ameh37@gmail.com",
//                   "phoneNumber": "+23409090397622",
//                   "websiteUrl": "https://ameh.com",
//                   "isApproved": false,
//                   "status": "active",
//                   "isBlocked": false,
//                   "canDecrypt": false,
//                   "createdAt": "2025-04-08T07:48:43.725Z",
//                   "updatedAt": "2025-04-08T07:48:43.725Z",
//                   "__v": 0
//               }
//           ],
//           "createdAt": "2025-04-08T07:48:43.713Z",
//           "updatedAt": "2025-04-09T08:31:01.740Z",
//           "membership": {
//               "_id": "67f4d4db73d24cc442e1def9",
//               "organization": "67f4d4db73d24cc442e1def6",
//               "user": "67f4d4db73d24cc442e1def4",
//               "isPrimary": true,
//               "status": "active",
//               "roles": [
//                   {
//                       "_id": "67f4d4db73d24cc442e1defa",
//                       "role": "admin",
//                       "permissions": [
//                           "*"
//                       ]
//                   }
//               ],
//               "createdAt": "2025-04-08T07:48:43.740Z",
//               "updatedAt": "2025-04-08T07:48:43.740Z",
//               "__v": 0
//           },
//           "lastLogin": "2025-04-09T08:31:01.739Z",
//           "id": "67f4d4db73d24cc442e1def4"
//       },
//       "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2N2Y0ZDRkYjczZDI0Y2M0NDJlMWRlZjQiLCJ0eXBlIjoidXNlciIsImVtYWlsIjoiZGF2aWQuYW1laDM3QGdtYWlsLmNvbSIsIm9yZ2FuaXphdGlvbklkIjoiNjdmNGQ0ZGI3M2QyNGNjNDQyZTFkZWY2IiwiaWF0IjoxNzQ0MTg3NDYxfQ.fSYuUtZtFR9nzONBORnUFwxrLKBKSagmvCDGy47glms",
//       "requireTwoFactor": false,
//       "organizationId": "67f4d4db73d24cc442e1def6"
//   }
// }
